import React, { useContext, useEffect, useRef, useState, Fragment } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPanel } from "../components/BannerPanel";
import { MenuUsuario } from "../components/MenuUsuario";
// import { CardsPostulaciones } from "../components/CardsPostulaciones";
import { Footer } from "../../../components/Landing/Footer";
// styled components
import { Row, Col, Empty, Table, Form, Select, Popover, Modal } from "antd";
import { Dropdown, Icon, Button } from "semantic-ui-react";
// hooks
import { useMisPostulaciones } from "../../../hooks/useMisPostulaciones";
// icons
import { CheckCircleOutlined, EditOutlined, InfoCircleOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
// data select
import {
  cantidadRegistros,
  QuienParticipaOptions,
  EstadosPostulacion,
} from "../../../utils/dataSelectOptions";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";
import { openNotification } from "../../../utils/Notifactions";
// another components
// import { ModalVerPropuesta } from "../../Admin/Convocatorias/GestionarPostulaciones/components/ModalVerPropuesta";
import { ModalVerPropuesta } from "./components/ModalVerPropuesta";
import { TemplateContext } from "../../../utils/template_context";
import { ObjNotificaciones } from "../../../config/notificaciones";
import { useEncrypt } from "../../../hooks/useEncrypt";
import { useNavigate } from "react-router-dom";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";
import moment from "moment";
import {ModalAvisoInfo} from "../../Landing/components/ModalAvisoInfo";


// colors state of postulation
const coloresEstado: any = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
  "Por completar": "#F28C02",
  "Anulado": "#0051E6"
};
// indetification types
const TiposIdentificacion: any = {
  "1": "Persona Natural",
  "3": "Grupo Conformado",
  "2": "Persona Jurídica",
};

export const Mispostulaciones = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk2 = () => {
    setIsModalOpen2(false);
  };

  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };

  const showModal2 = () => {
    setIsModalOpen2(true);
  };


  const {
    postulaciones,
    cargarPostulaciones,
    totalregistros,
    setTotalregistros,
    cantidadpáginas,
    cambiarCantidadPaginas,
    modal,
    setModal,
    setPostulaciones,
    descargarArchivo,
    obtenerLineasConvocatorias,
    lineasconvocatoria,
    postulacion,
    verPropuesta,
    datosFiltrados,
    setDatosFiltrados,
  } = useMisPostulaciones();

  useEffect(() => {
    localStorage.removeItem("id_postulacion");
    localStorage.removeItem("idConvocatoriaPostulacion");
    localStorage.removeItem("tipo_participante_postulacion");
    cargarPostulaciones();
    obtenerLineasConvocatorias();
  }, []);

  const [avisoInfo, setAvisoInfo] = useState<boolean>(true);

  interface PostulacionModel {
    id_postulacion: number;
    convocatoria_id: number;
    numero_documento_participante: number;
    nombre_propuesta: string;
    nombre_participante: string;
    jurados: Array<Object>;
    estado_jurado: boolean;
    fecha_creacion: string;
    tipo_participante: string;
    links: Array<Object>;
    nombre_convocatoria: string;
    categoria_linea_convocatoria: Array<Object>;
    fecha_apertura: string;
    fecha_actualizacion: string;
    particiapnte: Array<Object>;
    estado: string;
    documentos_generales: Array<Object>;
    documentos_tecnicos: Array<any>;
    documentos_administrativos: any;
    linea_convocatoria: number;
    radicado: string;
    pasos: {
      personales: boolean,
      categorias: boolean,
      administrativos: boolean,
      tecnicos: boolean,
      links: boolean
    };
  }

  const initialValuesPostulacionModel = {
    id_postulacion: 0,
    convocatoria_id: 0,
    numero_documento_participante: 0,
    nombre_propuesta: "",
    nombre_participante: "",
    jurados: [],
    estado_jurado: false,
    fecha_creacion: "",
    tipo_participante: "",
    links: [],
    nombre_convocatoria: "",
    categoria_linea_convocatoria: [],
    fecha_apertura: "",
    fecha_actualizacion: "",
    particiapnte: [],
    estado: "",
    documentos_generales: [],
    documentos_tecnicos: [],
    documentos_administrativos: [],
    linea_convocatoria: 0,
    radicado: "",
    pasos: {
      personales: true,
      categorias: false,
      administrativos: false,
      tecnicos: false,
      links: false
    }
  };

  const { decrypt, encrypt } = useEncrypt();
  const navigate = useNavigate();
  const [modalEditar, setModalEditar] = useState(false);
  const [postulacionEditar, setPostulacionEditar] = useState<PostulacionModel>(initialValuesPostulacionModel);

  const guardar = async (datos?: any) => {
    try {
        await apiParticipantes.cambiarEstadoPostulacion({ id_postulacion: datos.id_postulacion, estado: "Anulado" });
      } catch (error) {
        console.log(error)
    }
    window.location.reload();
  }

  const validateFormsCompleted = (datos) => {

    let pasos = {
      personales: true,
      categorias: false,
      administrativos: false,
      tecnicos: false,
      links: false
    }

    if (datos.links && datos.links !== null && datos.links.length > 0) {
      pasos.links = true;
    }

    if (datos.documentos_tecnicos && datos.documentos_tecnicos !== null && datos.documentos_tecnicos.length > 0) {
      const tecnicos = datos.documentos_tecnicos.filter((x) => x.url_participante && x.url_participante !== "");
      if (tecnicos && tecnicos.length > 0) {
        pasos.tecnicos = true;
      }
    }

    if (datos.documentos_administrativos && datos.documentos_administrativos !== null && datos.documentos_administrativos.length > 0) {
      const administrativos = datos.documentos_administrativos.filter((x) => x.url_participante && x.url_participante !== "");
      if (administrativos && administrativos.length > 0) {
        pasos.administrativos = true;
      }
    }

    if (datos.categoria_linea_convocatoria && datos.categoria_linea_convocatoria !== null) {
      pasos.categorias = true;
    }

    datos.pasos = pasos;
    localStorage.setItem('id_postulacion', encrypt(datos.id_postulacion.toString()));
    if(!localStorage.getItem('idConvocatoriaPostulacion')){
      localStorage.setItem('idConvocatoriaPostulacion', encrypt(datos.convocatoria_id.toString()))
    }
    if(!localStorage.getItem("tipo_participante_postulacion")){
      localStorage.setItem("tipo_participante_postulacion", `${datos.tipo_participante - 1}`);
    }
    //Se resta uno debido a que los documentos evaluan a los tipos de participantes del 0 al 2 y no del 1 al 3 como al momento del registro
    setPostulacionEditar(datos);
    setModalEditar(true);
  }

  // pagination table
  function itemRenderTable(current: any, type: any, originalElement: any) {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  }

  const context = useContext(TemplateContext);
  // columns postulation
  const columns: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Nombre de proyecto",
      width: 300,
      fixed: context.device === "md" ? "left" : false,
      render: (data: any) =>
      <span style={{whiteSpace: "pre-line"}}>
        {data?.nombre_propuesta}
      </span>,
    },
    {
      title: "Código",
      width: 80,
      render: (data: any) => <span>{data?.radicado}</span>,
    },
    {
      title: "Estado",
      key: "estado",
      width: 150,
      render: (data: any) =>
      <span style={{ color: coloresEstado[data?.estado] }}>
        {data?.estado == 'Sin revisar' ? 'Inscrito sin revisar' : data?.estado}
      </span>,
    },
    {
      title: "Linea convocatoria",
      ellipsis: true,
      width: 300,
      render: (data: any) => {
        return <span style={{whiteSpace: "pre-line"}}>{data?.linea_convocatoria}</span>;
      },
    },
    {
      title: "Categoría",
      width: 150,
      render: (datos: any) => {
        return (
          <>
            <span style={{whiteSpace: "pre-line"}}>{datos.categoria_linea_convocatoria}</span>
          </>
        );
      },
    },
    {
      title: "Tipo participante",
      // width: 140,
      render: (datos: any) => {
        return (
          <>
            <span>{TiposIdentificacion[datos.tipo_participante]}</span>
          </>
        );
      },
    },
    {
      title: () => (
        <div>
          <div className="titleAcciones">Acciones</div>
          <div className="controls">
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Ver
            </div>
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Editar
            </div>
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Anular
            </div>
          </div>
        </div>
      ),
      width: 100,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <>
          <div className="controls">
            <Button
              onClick={() => verPropuesta(datos)}
              className="botones-acciones"
              icon={<Icon name="eye" />}
            />
            {
            datos?.estado === "Por completar" &&
              <Button
                onClick={
                  () => {
                    showModal()
                    validateFormsCompleted(datos)
                  }
                }
                className="button-ant-ant"
                icon={<Icon name="pencil" />}
              />
            }
            {
            datos?.estado === "Por guardar" &&
              <Button
                onClick={
                  () => {
                    showModal()
                    validateFormsCompleted(datos)
                  }
                }
                className="button-ant-ant"
                icon={<Icon name="pencil" />}
                />
            }
            {
              datos?.estado === "Anulado" &&
                <Button
                  onClick={
                    () => {
                      showModal()
                      validateFormsCompleted(datos)
                    }
                  }
                  className="button-ant-ant"
                  icon={<Icon name="pencil" />}
                />
            }
            {
            datos?.estado === "Sin revisar" &&
              <Button
                onClick={async ()  => {
                  let convocatoria = await apiConvocatorias.getConvocatoriaById(datos.convocatoria_id)
                  for(const element of convocatoria.data.fechas){
                    if(element.clave == "Cierre"){

                      let fechaserver = moment()
                      let fechaActual = fechaserver

                      let cierreAct = new Date(element.valormax);
                      cierreAct.setHours(cierreAct.getHours() - 1);

                      if(fechaActual.isBefore(moment(cierreAct))){
                        showModal2();
                        validateFormsCompleted(datos);
                      } else{
                          return openNotification({
                          titulo: "Error",
                          descripcion: `No es permitido anular una propuesta después del cierre de la convocatoria`,
                          placement: "bottomRight",
                        });
                      }
                    }
                  }
                }
              }
              className="botones-acciones boton-borrar-adminconvocatorias"
              icon={<Icon name="trash alternate outline" />}
              />
            }
            {
            datos?.estado === "Inscrito sin revisar" &&
              <Button
                onClick={async ()  => {
                    let convocatoria = await apiConvocatorias.getConvocatoriaById(datos.convocatoria_id)
                    for(const element of convocatoria.data.fechas){
                      if(element.clave == "Cierre"){

                        let fechaserver = moment()
                        let fechaActual = fechaserver

                        let cierreAct = new Date(element.valormax);
                        cierreAct.setHours(cierreAct.getHours() - 1);

                        if(fechaActual.isBefore(moment(cierreAct))){
                          showModal2();
                          validateFormsCompleted(datos);
                        } else{
                            return openNotification({
                            titulo: "Error",
                            descripcion: `No es permitido anular una propuesta después del cierre de la convocatoria`,
                            placement: "bottomRight",
                          });
                        }
                      }
                    }
                  }
                }
                className="botones-acciones boton-borrar-adminconvocatorias"
                icon={<Icon name="trash alternate outline" />}
              />
            }
            {
              datos?.linea_convocatoria === 'Banco de artistas - PP - 2025'  &&
              <Button
                onClick={async ()  => {
                    showModal2();
                    validateFormsCompleted(datos);
                  }
                }
                className="botones-acciones boton-borrar-adminconvocatorias"
                icon={<Icon name="trash alternate outline" />}
              />
            }
          </div>
        </>
      ),
    },
  ];
  const [tipoParticipante, setTipoParticipante] = useState(0);
  const handleParticipante = (id_participante: number) => {
    setTipoParticipante(id_participante);
  };
  const [estado, setEstado] = useState("");
  const handleEstado = (estado: string) => {
    setEstado(estado);
  };
  const filtrar = () => {
    if (tipoParticipante !== 0) {
      if (estado !== "") {
        const datosFiltrados = postulaciones.filter(
          (x: any) =>
            x.tipo_participante == tipoParticipante && x.estado == estado
        );
        setDatosFiltrados(datosFiltrados);
        return;
      }
      const datosFiltrados = postulaciones.filter(
        (x: any) => x.tipo_participante == tipoParticipante
      );
      setDatosFiltrados(datosFiltrados);
      setTotalregistros(datosFiltrados.length);
    }
    if (estado !== "") {
      if (tipoParticipante !== 0) {
        const datosFiltrados = postulaciones.filter(
          (x: any) =>
            x.tipo_participante == tipoParticipante && x.estado == estado
        );
        setDatosFiltrados(datosFiltrados);
        return;
      }
      const datosFiltrados = postulaciones.filter(
        (x: any) => x.estado == estado
      );
      setDatosFiltrados(datosFiltrados);
      setTotalregistros(datosFiltrados.length);
    }
  };
  const formRef = useRef<any>();
  const borrarFiltro = () => {
    setDatosFiltrados(postulaciones);
    console.log(postulaciones.length);
    setTotalregistros(postulaciones.length);
    formRef.current.resetFields();
  };
  return (
    <div>
      <div className="row mt-4">
        <div className="col-12 font-family-Montserrat-Regular font-size-14px">
          {" "}
          Usa los filtros para encontrar lo que buscas
        </div>
      </div>
      <Form name="basic" size="large" layout="vertical" ref={formRef}>
        <div className="row">
          <div className="col-6 col-md-4 col-lg-6 mb-0 mt-0">
            <Form.Item label="Tipo participante" name="perfil_participante">
              <Select dropdownMatchSelectWidth={false}
                allowClear
                placeholder="Seleccionar..."
                onChange={handleParticipante}
              >
                {QuienParticipaOptions.map(({ value, text }, i) => (
                  <Select.Option key={i} value={value}>{text}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-6 col-md-4 col-lg-6 mb-0 mt-0">
            <Form.Item label="Estado" name="estado">
              <Select dropdownMatchSelectWidth={false}
                allowClear
                placeholder="Seleccionar..."
                onChange={handleEstado}
              >
                {EstadosPostulacion.map(({ value, text }, i) => (
                  <Select.Option key={i} value={value}>{text}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-12 justify-content-flex-end">
            <Button
              className="button-azul-ghost no-margin"
              onClick={borrarFiltro}
            >
              Limpiar filtros
            </Button>
            <Button className="button-azul-radius no-margin" onClick={filtrar}>
              Buscar
            </Button>
          </div>
        </div>
      </Form>
      <div className="row-shadow2 ms-1 mt-4 mb-4">
        <div className="row">
          <div className="col-12 col-md-6 pb-2 font-size-14px font-family-Montserrat-SemiBold">
            Gestionar postulación de proyectos
          </div>
          <div className="col-12 col-md-6 pb-2">
            <div className="row g-2">
              <div className="col-10 col-md-10  col-xl-10 col-xxl-11 d-flex justify-content-end align-content-center">
                <span className="pe-4 col d-flex justify-content-md-end">
                  Total :{" "}
                  <span className="font-color-F28C02">{totalregistros}</span>
                </span>
                <span className="d-flex flex-nowrap pt-1 justify-content-end font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                  Registros por página
                </span>
              </div>
              <div className="col-2 col-md-2 col-xl-2 col-xxl-1 justify-content-between">
                <Dropdown
                  fluid
                  className="select-registros-adminconvocatoria no-margin"
                  defaultValue={cantidadpáginas}
                  options={cantidadRegistros}
                  icon={<IconFlechareg/>
                    }
                  onChange={(e, { value }) => cambiarCantidadPaginas(e, value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12">
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              pagination={{
                position: ["bottomRight"],
                itemRender: itemRenderTable,
                pageSize: cantidadpáginas,
              }}
              columns={columns}
              dataSource={datosFiltrados}
              scroll={{ x: 1500, y: 300 }}
              size="small"
              rowClassName="sizeTable table-row"
              className="table-ant-design-modify"
              bordered={false}
            />
          </div>
        </div>
        <ModalVerPropuesta
          modal={modal}
          AceptarModal={() => setModal(false)}
          postulacion={postulacion}
          descargarArchivo={descargarArchivo}
          CancelarModal={() => setModal(false)}
          lineasConvocatoria={lineasconvocatoria}
        />

        <Modal
          style={{ top: 60, zIndex: 3, background: "transparent" }}
          visible={isModalOpen}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closeIcon="X"
          onOk={handleOk}
          onCancel={handleCancel}
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa modal-formularios-completar"
        >
          {console.log('postulacionEditar',postulacionEditar)}
          {
            postulacionEditar ?
              <div>
                <div className="row-shadow">
                  <div className="row">
                    <div className="text-center col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_azul">
                      Continua con tu postulación de la convocatoria
                      <br />
                      Radicado: {postulacionEditar.radicado}
                    </div>
                    <div className="text-center p-3 col-12 font-size-16px font-family-Montserrat-SemiBold justify-content-center">
                      Selecciona el paso en el que deseas continuar tú postulación
                    </div>
                  </div>
                  <div className="row border-top mt-4 justify-content-flex-center">
                    <div className="col-6 justify-content-flex-start">
                      {/* <Button
                    className="button-azul-radius mb-0"
                    onClick={AceptarModal}
                  >
                    ACEPTAR
                  </Button> */}
                    </div>
                  </div>
                  <div id="printThis" className="row-shadow mt-2">
                    <div className="row">
                      <div className="col-12 border-bottom font-family-Montserrat-Regular font-size-14px pb-3">
                        Formularios completados
                      </div>
                    </div>
                    <div className="row p-3" style={{ height: "200px", overflowY: "auto", fontSize: '10px' }}>

                      <div className="col-6 font-family-Montserrat-Regular font-size-12px">
                        Datos personales
                      </div>
                      <div className="col-3 font-family-Montserrat-Regular font-size-12px">
                        <CheckCircleOutlined className="font-color-00904C font-size-16px me-2" />
                        Completado
                      </div>
                      <a onClick={() => navigate('/Usuario/Seleccionarrol')} className="col-3 font-family-Montserrat-Regular font-size-12px">
                        <EditOutlined className="font-color-F28C02 font-size-16px me-2" />
                        Continuar
                      </a>

                      {
                        postulacionEditar.tipo_participante == '3' ?
                        <Fragment>
                          <div className="col-6 font-family-Montserrat-Regular font-size-12px">
                            Agregar participantes
                          </div>
                          <div className="col-3 font-family-Montserrat-Regular font-size-12px">
                            <CheckCircleOutlined className="font-color-00904C font-size-16px me-2" />
                            Completado
                          </div>
                          <a onClick={() => navigate('/Usuario/agregarParticipante')} className="col-3 font-family-Montserrat-Regular font-size-12px">
                            <EditOutlined className="font-color-F28C02 font-size-16px me-2" />
                            Continuar
                          </a>
                        </Fragment> :
                        ''
                      }

                      <div className="col-6 font-family-Montserrat-Regular font-size-12px">
                        Seleccionar categoría
                      </div>
                      <div className="col-3 font-family-Montserrat-Regular font-size-12px">
                        {
                          postulacionEditar.pasos.categorias ?
                            <div>
                              <CheckCircleOutlined className="font-color-00904C font-size-16px me-2" />
                              Completado
                            </div>
                            :
                            <div>
                              <InfoCircleOutlined className="texto_azul font-size-16px me-2" />
                              Incompleto
                            </div>
                        }
                      </div>
                      <a onClick={() => navigate('/Usuario/seleccionarCategoria')} className="col-3 font-family-Montserrat-Regular font-size-12px">
                        <EditOutlined className="font-color-F28C02 font-size-16px me-2" />
                        Continuar
                      </a>

                      <div className="col-6 font-family-Montserrat-Regular font-size-12px">
                        Documentos Administrativos
                      </div>
                      <div className="col-3 font-family-Montserrat-Regular font-size-12px">
                        {
                          postulacionEditar.pasos.administrativos ?
                            <div>
                              <CheckCircleOutlined className="font-color-00904C font-size-16px me-2" />
                              Completado
                            </div>
                            :
                            <div>
                              <InfoCircleOutlined className="texto_azul font-size-16px me-2" />
                              Incompleto
                            </div>
                        }
                      </div>
                      <a onClick={() => navigate('/usuario/Documentosadministrativos')} className="col-3 font-family-Montserrat-Regular font-size-12px">
                        <EditOutlined className="font-color-F28C02 font-size-16px me-2" />
                        Continuar
                      </a>

                      <div className="col-6 font-family-Montserrat-Regular font-size-12px">
                        Documentos Técnicos
                      </div>
                      <div className="col-3 font-family-Montserrat-Regular font-size-12px">
                        {
                          postulacionEditar.pasos.tecnicos ?
                            <div>
                              <CheckCircleOutlined className="font-color-00904C font-size-16px me-2" />
                              Completado
                            </div>
                            :
                            <div>
                              <InfoCircleOutlined className="texto_azul font-size-16px me-2" />
                              Incompleto
                            </div>
                        }
                      </div>
                      <a onClick={() => navigate('/usuario/Documentostecnicos')} className="col-3 font-family-Montserrat-Regular font-size-12px">
                        <EditOutlined className="font-color-F28C02 font-size-16px me-2" />
                        Continuar
                      </a>

                      <div className="col-6 font-family-Montserrat-Regular font-size-12px">
                        Finalizar propuesta
                      </div>
                      <div className="col-3 font-family-Montserrat-Regular font-size-12px">
                        {
                          postulacionEditar.pasos.links ?
                            <div>
                              <CheckCircleOutlined className="font-color-00904C font-size-16px me-2" />
                              Completado
                            </div>
                            :
                            <div>
                              <InfoCircleOutlined className="texto_azul font-size-16px me-2" />
                              Incompleto
                            </div>
                        }
                      </div>
                      <a onClick={() => {
                        if (postulacionEditar.pasos.tecnicos && postulacionEditar.pasos.categorias) {
                          navigate('/usuario/Agregarurl')
                        } else {
                          ObjNotificaciones.MSG_ERROR('warning', '¡Faltan formularios por completar!', 'Por favor, completa todos los formularios anteriores para seguir con este paso');
                        }
                      }} className="col-3 font-family-Montserrat-Regular font-size-12px">
                        <EditOutlined className="font-color-F28C02 font-size-16px me-2" />
                        Continuar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              :
              <p>No se pudo cargar esta convocatoria</p>
          }
        </Modal>

        <Modal
          style={{ top: 120, zIndex: 3, background: "transparent" }}
          visible={isModalOpen2}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closeIcon="X"
          onOk={handleOk2}
          onCancel={handleCancel2}
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa modal-formularios-completar"
        >
          {
            postulacionEditar ?
              <div>
                <div className="row-shadow">
                  <div className="row">
                    <div className="text-center col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_azul">
                      ¿Desea anular la postulación con radicado: {postulacionEditar.radicado}?
                    </div>
                    <div className="text-center col-12">
                      <Button className="button-gray-ghost" onClick={handleCancel2}>
                        CANCELAR
                      </Button>
                      <Button className="button-azul-radius" onClick={() => {
                        guardar(postulacionEditar);
                        handleOk2;
                        }}>
                        ACEPTAR
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              :
              <p>No se pudo cargar esta convocatoria</p>
          }
        </Modal>
        <ModalAvisoInfo
          visualizar={avisoInfo}
          setVisualizar={setAvisoInfo}
        />
      </div>
      {/*
      </div>
   </div>
</div>
<Footer />
*/}
    </div >
  );
};
